import React, { forwardRef } from 'react';
import InputMask, { Props } from 'react-input-mask';
import { Input } from '../Input';
import { IInputProps } from '../models';

export interface IInputPhoneProps extends IInputProps, Pick<Props, 'mask'> {}

export const InputPhone = forwardRef<HTMLInputElement, IInputPhoneProps>(
  ({ mask, value, disabled, onBlur, onChange, ...rest }, ref) => {
    return (
      <InputMask mask={mask} value={value} disabled={disabled} onBlur={onBlur} onChange={onChange}>
        {/* @ts-ignore */}
        {() => <Input {...rest} password={false} ref={ref} disabled={disabled} />}
      </InputMask>
    );
  },
);
